"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unfundedPositionsSelector = exports.productsSelector = exports.productPositionSelector = exports.productPositionAssetsSelector = exports.getProductByIdSelector = exports.fundedPositionsSelector = exports.fetchingSelector = void 0;
var _reselect = require("reselect");
var _positionFormatter = _interopRequireDefault(require("../../helpers/positionFormatter"));
var _positionSelectors = require("./positionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var productsSelector = exports.productsSelector = function productsSelector(state) {
  return state.apexCore.product.products;
};
var assetsSelector = function assetsSelector(state) {
  return state.productManifest.manifest;
};
var fetchingSelector = exports.fetchingSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.product;
}, function (state) {
  return state.apexCore.position;
}, function (state) {
  return state.productManifest;
}], function (product, position, manifest) {
  return product.fetching || position.fetching || manifest.fetching;
});
var productPositionSelector = exports.productPositionSelector = (0, _reselect.createSelector)([productsSelector, function (state) {
  return state.apexCore.product.decimalPlaces;
}, _positionSelectors.positionSelector], function (products, decimalPlaces, positions) {
  return products.map(function (product) {
    var position = positions[product.ProductId];
    if (!position) {
      return product;
    }
    var positionDecimals = decimalPlaces[product.Product];
    var formattedPosition = (0, _positionFormatter["default"])(position, positionDecimals);
    return _objectSpread(_objectSpread({}, formattedPosition), product);
  });
});
var productPositionAssetsSelector = exports.productPositionAssetsSelector = (0, _reselect.createSelector)([productPositionSelector, assetsSelector], function (products, assets) {
  return products.map(function (product) {
    var asset = assets[product.Product] || {
      iconFileName: product.Product + 'DEFAULT_ICON'
    };
    return _objectSpread(_objectSpread({}, product), asset);
  });
});
var getProductByIdSelector = exports.getProductByIdSelector = (0, _reselect.createSelector)([productPositionAssetsSelector, function (state, productId) {
  return productId;
}], function (products, productId) {
  return products.find(function (item) {
    return item.ProductId === productId;
  });
});
var fundedPositionsSelector = exports.fundedPositionsSelector = (0, _reselect.createSelector)(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount !== '-';
  });
});
var unfundedPositionsSelector = exports.unfundedPositionsSelector = (0, _reselect.createSelector)(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount === '-';
  });
});